import { signupFormSchema } from "@redotech/redo-marketing-common/signup-form/signup-form-schema";
import * as z from "zod/v4";

export const updateSignupForm = {
  name: "updateSignupForm" as const,
  input: z.object({ formId: z.string(), form: signupFormSchema }),
  output: z.literal("success"),
};
